<template>
  <div class="app-button">
    {{ label }}
  </div>
</template>

<script src="./AppButton.js" />
<style scoped src="./AppButton.scss" lang="scss" />